module.exports = __webpack_public_path__ + "img/d_8.35f5791d.png";